import { Link } from "react-router-dom";
import { LegalLayout } from "@/components/legal/LegalLayout";
import { LegalP, LegalSection, LegalUl } from "@/components/legal/LegalProse";
import { OPERATOR } from "@/lib/legal";
import { tw } from "@/lib/theme";

export function AdsPage() {
  return (
    <LegalLayout
      title="Advertising disclosure"
      subtitle="How ads work on Daywia (Google AdMob)."
    >
      <LegalSection title="Where ads appear">
        <LegalUl
          items={[
            "Home feed — native-style posts and occasional banner placements.",
            "Drift feed and profile Drift viewer — full-screen native ads between videos.",
            "Chat inbox list — banner after a number of threads (not inside message threads).",
            "Ads are labeled Sponsored per AdMob policy.",
          ]}
        />
      </LegalSection>

      <LegalSection title="What data ads may use">
        <LegalP>
          Google AdMob may collect advertising IDs, device type, coarse location, and interaction
          data to serve and measure ads. This is governed by{" "}
          <a
            href="https://policies.google.com/privacy"
            className={tw.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            Google&apos;s Privacy Policy
          </a>
          . You can limit ad personalization in Android Settings → Google → Ads.
        </LegalP>
      </LegalSection>

      <LegalSection title="Children">
        <LegalP>
          We do not knowingly serve personalized ads to users we identify as under 13. See{" "}
          <Link to="/child-safety" className={tw.link}>
            Child safety
          </Link>
          .
        </LegalP>
      </LegalSection>

      <LegalSection title="More information">
        <LegalP>
          For how we handle personal data overall, read our{" "}
          <Link to="/privacy" className={tw.link}>
            Privacy Policy
          </Link>
          . {OPERATOR.product} does not sell your personal information to advertisers.
        </LegalP>
      </LegalSection>
    </LegalLayout>
  );
}
